import type { User } from '../types';
import { isNutritionConsultant } from './userType';

export const DEFAULT_HOUSEHOLD_LIMIT = 5;

export function getUserHouseholdLimit(user: Pick<User, 'householdEntitlement' | 'subscription' | 'role' | 'userType'>): number {
    if (
        isNutritionConsultant(user) &&
        typeof user.householdEntitlement === 'number' &&
        user.householdEntitlement > 0
    ) {
        return Math.floor(user.householdEntitlement);
    }

    const fromPlan = user.subscription?.planDetails?.households;
    if (typeof fromPlan === 'number' && fromPlan > 0) {
        return Math.floor(fromPlan);
    }

    return DEFAULT_HOUSEHOLD_LIMIT;
}

export function canUserCreateHousehold(
    user: Pick<User, 'householdEntitlement' | 'subscription' | 'role' | 'userType'>,
    ownedHouseholdCount: number,
): boolean {
    if (user.role === 'superuser') return true;
    return ownedHouseholdCount < getUserHouseholdLimit(user);
}
